export function sanitizeClientSessionData(data) {
    if (!data || typeof data !== 'object') {
        return null;
    }

    return {
        id: data.id ?? null,
        company_id: data.company_id ?? null,
        number: data.number ?? null,
        physical_number: data.physical_number ?? null,
        location: data.location ?? null,
        older: data.older ?? null,
        client_name: data.client_name ?? data.name ?? null,
        event: data.event ?? null,
        sessionUUID: data.sessionUUID ?? null,
    };
}
